<template>
  <Modal :value="visible" @on-cancel="cancelHandler" footer-hide
    :title="currApiSetting && currApiSetting.id ? '编辑接口' : '增加接口'" width="650">
    <div class="container">
      <Form :model="formData" ref="form" label-position='left' :label-width="100">
        <FormItem label="接口名称" prop="name">
          <Input v-model="formData.name" placeholder="" />
        </FormItem>
        <FormItem label="接口类型" prop="method">
          <Input v-model="formData.method" placeholder="" />
        </FormItem>
        <FormItem label="接口地址" prop="url">
          <Input v-model="formData.url" placeholder="" readonly>
          <Button slot="append" icon="md-copy" @click="copyUrl" :disabled="!formData.url">复制</Button>
          </Input>
        </FormItem>
        <FormItem label="获取参数" prop="content">
          <Input v-model="formData.content" placeholder="" />
        </FormItem>
        <Divider />
        <div class="extension-info">
          <h4>事件信息</h4>
          <div class="section-title">动作</div>
          <div v-for="(action, index) in formData.action" :key="'action-' + index" class="dynamic-item">
            <Input v-model="action.name" placeholder="事件名称" style="width: 22%; margin-right: 5px;" />
            <Input v-model="action.key" placeholder="参数值" style="width: 22%; margin-right: 5px;" />

            <form-item-jump-action v-model="action.action_data" style="width: 51%" />
            <!-- <Input v-model="action.action" placeholder="动作" style="width: 22%; margin-right: 5px;" /> -->
            <!-- <Input v-model="action.action_data" placeholder="Value" style="width: 22%; margin-right: 5px;" /> -->
            <Button type="error" size="small" @click="removeAction(index)" icon="md-trash"></Button>
          </div>
          <Button type="dashed" size="small" @click="addAction" style="width: 100%; margin-top: 5px;">
            <Icon type="md-add" /> 添加动作 
          </Button>
        </div>
        <div class="flex flex-end" style="margin-top: 20px;">
          <Button style="margin-right: 20px" @click="cancelHandler">取消</Button>
          <Button type="primary" @click="submit">确定</Button>
        </div>
      </Form>
    </div>
  </Modal>
</template>
<script>
import { FormItem } from 'view-design';
import FormItemJumpAction from '../../../components/FormItemJumpAction.vue';
import { getReceiveApiUrlA } from '@/server/api';

export default {
  components: {
    FormItemJumpAction
  },
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    currApiSetting: {
      type: Object,
    }
  },
  data() {
    return {
      formData: {
        name: '',
        url: '',
        content: '',
        method: 'POST',
        content_type: 'application/json',
        action: [],
      },
      loading: false,
    }
  },
  watch: {
    currApiSetting(val) {
      if (!val) return
      const action = val.action?.map(item => {
        return {
          name: item.name,
          key: item.key,
          action: '',
          action_data: `${item.scene},${item.node}`,
        }
      }) || []
      this.formData = {
        ...val,
        action: action,
        // headers: header,
      }
    },
    async visible(val) {
      if (val && !this.currApiSetting) {
        await this.fetchApiUrl();
      }
    },
  },
  methods: {
    async fetchApiUrl() {
      try {
        this.loading = true;
        const res = await getReceiveApiUrlA();
        if (res && res.data) {
          this.formData.url = res.data.url || res.data;
        }
      } finally {
        this.loading = false;
      }
    },
    copyUrl() {
      if (!this.formData.url) {
        this.$Message.warning('暂无接口地址可复制');
        return;
      }
      // 创建临时输入框来复制
      const input = document.createElement('input');
      input.value = this.formData.url;
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand('copy');
        this.$Message.success('接口地址已复制到剪贴板');
      } catch (err) {
        this.$Message.error('复制失败，请手动复制');
      }
      document.body.removeChild(input);
    },
    submit() {
      console.log(this.formData, 'formData')
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        const data = {
          ...this.formData,
          type: 1,
          action: this.formData.action.map(item => {
            const [scene = '', node = ''] = item.action_data?.split(',') || []
            return {
              name: item.name,
              key: item.key,
              action: '',
              scene,
              node,
            }
          })
        }
        this.$emit('onSubmit', data);
        this.cancelHandler();
      })
    },
    cancelHandler() {
      this.$refs.form.resetFields()
      this.formData = {
        name: '',
        url: '',
        content: '',
        method: 'POST',
        content_type: 'application/json',
        action: [],
      }
      this.$emit('change', false)
      this.$emit('onCancel')
    },
    addAction() {
      this.formData.action.push({
        key: '',
        value: ''
      })
    },
    removeAction(index) {
      this.formData.action.splice(index, 1)
    },
  }
}
</script>
<style lang="scss" scoped>
.extension-info {
  h4 {
    margin-bottom: 10px;
    font-weight: 600;
    color: #333;
  }

  .section-title {
    font-size: 14px;
    font-weight: 500;
    color: #666;
    margin-bottom: 8px;
    margin-top: 12px;
  }

  .dynamic-item {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }
}
</style>